module.exports = __webpack_public_path__ + "static/media/success.21973d2e.jpg";